import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CinemaDataProvider } from 'libs/core/src/lib/data-provider/cinema.data-provider';
import { UserDataProvider } from 'libs/core/src/lib/data-provider/user.data-provider';
import { LoaderEnum } from 'libs/core/src/lib/enum/loader.enum';
import { UserApiModel } from 'libs/core/src/lib/model/api-model/user/user.api.model';
import { UserViewModel } from 'libs/core/src/lib/model/view-model/user/user.view.model';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { AuthStateService } from 'libs/core/src/lib/state/auth.state.service';
import { forkJoin, merge, noop, Observable, of, Subject } from 'rxjs';

@Component({
  template: ''
})
export class UserProfileComponent implements OnInit {
  protected user: UserViewModel;
  public user$ = new Subject<UserViewModel>();
  public profileForm: FormGroup;
  public preferencesForm: FormGroup;

  constructor(
    protected userDataProvider: UserDataProvider,
    protected loaderService: LoaderService,
    protected authStateService: AuthStateService,
    protected cinemaDataProvider: CinemaDataProvider
  ) {}

  ngOnInit() {
    this.authStateService.state$.subscribe((user) => {
      if (user?.token) {
        this.userDataProvider.get(user?.token).subscribe({
          next: (user: UserViewModel) => {
            this.user = user;
            this.user$.next(user);
          },
          complete: () => noop()
        });
      }
    });
  }

  onAfterInit() {}

  public onSubmit() {
    if (!this.profileForm.valid) {
      console.log(this.profileForm.controls);
      return;
    }

    const formRaw = this.profileForm.getRawValue();

    if (Array.isArray(formRaw.agreements)) {
      formRaw.agreements = formRaw.agreements
        .map((checked: boolean, i: number) => (checked ? (this as any).agreements[i]?.id : null))
        .filter((id: string | null) => id !== null);
    }

    let user = { ...this.user.toApiModel(), ...this.profileForm.getRawValue() } as UserApiModel;
    if (this.profileForm.controls['birthday'].value) {
      user.birthday = this.profileForm.controls['birthday'].value.toISO();
    }

    this.loaderService.showLoader(LoaderEnum.MAIN);

    forkJoin([this.userDataProvider.update(user, undefined), this.updateFavourites(this.profileForm)]).subscribe({
      complete: () => this.loaderService.hideLoader(LoaderEnum.MAIN)
    });
  }

  updateFavourites(form: FormGroup): Observable<any> {
    const favouriteCinemas$ = Array.isArray(form.controls['favouriteCinemas'].value)
      ? this.userDataProvider.setFavouriteCinemaList(form.controls['favouriteCinemas'].value.filter((f) => f.checked).map((m) => m.id))
      : of(null);

    const favouriteGenres$ = Array.isArray(form.controls['favouriteGenres'].value)
      ? this.userDataProvider.setFavouriteGenreList(form.controls['favouriteGenres'].value.filter((f) => f.checked).map((m) => m.id))
      : of(null);

    return merge(favouriteCinemas$, favouriteGenres$);
  }
}
